var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"manual-home"},[_c('el-row',[_c('el-col')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }